const styles = {
  paper: {
    p: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
    mb: '10px',
  },
  inputBase: {
    ml: 1,
    flex: 1,
  },
  iconButton: {
    p: '10px',
  },
};

export default styles;
